'use client';

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
  ReactElement,
} from 'react';

import { STORAGE_KEYS, getStoredNumber, setStoredNumber } from '@/lib/utils/storage';

interface UserContextType {
  userId: number | null;
  setUserId: React.Dispatch<React.SetStateAction<number | null>>;
}

const defaultContextValue: UserContextType = {
  userId: null,
  setUserId: () => {
    console.warn('setUserId is not initialized');
  },
};

const UserContext = createContext<UserContextType>(defaultContextValue);

export const UserProvider = ({ children }: { children: ReactNode }): ReactElement => {
  const [userId, setUserId] = useState<number | null>(null);

  useEffect(() => {
    const savedUserId = getStoredNumber(STORAGE_KEYS.USER_ID);
    if (savedUserId !== null) {
      setUserId(savedUserId);
    }
  }, []);

  useEffect(() => {
    if (userId !== null) {
      setStoredNumber(STORAGE_KEYS.USER_ID, userId);
    }
  }, [userId]);

  return <UserContext.Provider value={{ userId, setUserId }}>{children}</UserContext.Provider>;
};

export const useUserId = () => useContext(UserContext);
